import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { useNavigate, useParams, useLocation} from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useGetStudentNewAnswersQuery } from '../slices/students/questionsApiSlice';

const StudentNavbar = () => {

    const { pageNumber } = useParams();
    const location = useLocation(); 

    const { data, isLoading, error } = useGetStudentNewAnswersQuery({pageNumber});
    

    return (
        <nav className="sidenav navbar navbar-vertical  fixed-left  navbar-expand-xs navbar-light bg-white sidebar34 " id="sidenav-main">
            <div className="scrollbar-inner ">
                <div className="sidenav-header  d-flex  align-items-right navLog" >
                    <a className="navbar-brand " href=""> <span className="brandcolor">Ask to Learn</span>
                        <img src="../../assets/img/log4.png" className="navbar-brand-img"  style={{ marginLeft: "2%", height: "170%",  marginTop: "-11%",}}  />
                    </a>
                </div><br />
                <div className="navbar-inner ">
                    <div className="collapse navbar-collapse" id="sidenav-collapse-main"><br />
                        <ul className="navbar-nav ">    
                            <div className={`${location.pathname == '/studentnewanswer' ? 'active23' : ''}`}>
                            <li className="nav-item mynav nav-link"> 
                                <i className="ni ni-ungroup text-info navLink nav23"></i>
                                <LinkContainer to='/studentnewanswer' >
                                <span className="nav-link-text navLink navBadge ">
                                    New Answers
                                    <span className="button__badge">
                                        {data?.count}
                                    </span>
                                </span>
                                </LinkContainer>
                            </li>
                            </div>
                            <div className={`${location.pathname == '/studentasknew' ? 'active23' : ''}`}>
                            <li className="nav-item mynav nav-link "> 
                                <i className="ni ni-ui-04 text-success navLink nav23"></i>
                                <LinkContainer to='/studentasknew' >
                                <span className="nav-link-text navLink ">Ask New Question</span>
                                </LinkContainer>
                            </li>
                            </div>
                            <div className={`${location.pathname == '/studentsubjects' ? 'active23' : ''}`}>
                            <li className="nav-item mynav nav-link"> 
                                <i className="ni ni-align-left-2 text-teal navLink nav23"></i>
                                <LinkContainer to='/studentsubjects' >
                                <span className="nav-link-text navLink">My Subjects</span>
                                </LinkContainer>
                            </li>
                            </div>
                            <div className={`${location.pathname == '/studentteachers' ? 'active23' : ''}`}>
                            <li className="nav-item mynav nav-link"> 
                                <i className="ni ni-single-copy-04 text-pink navLink nav23"></i>
                                <LinkContainer to='/studentteachers' >
                                <span className="nav-link-text navLink">My Teachers</span>
                                </LinkContainer>                    
                            </li>
                            </div>
                            <div className={`${location.pathname == '/studentprofile' ? 'active23' : ''}`}>
                            <li className="nav-item mynav nav-link"> 
                                <i className="ni ni-circle-08 text-primary navLink nav23"></i>
                                <LinkContainer to='/studentprofile' >
                                <span className="nav-link-text navLink">My Profile</span>
                                </LinkContainer>
                            </li>
                            </div>
                            <div className={`${location.pathname == '/studentsubscriptions' ? 'active23' : ''}`}>
                            <li className="nav-item mynav nav-link"> 
                                <i className="ni ni-archive-2 text-green navLink nav23"></i>
                                <LinkContainer to='/studentsubscriptions' >
                                <span className="nav-link-text navLink">Subscriptions</span>
                                </LinkContainer>
                            </li> 
                            </div>                
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default StudentNavbar
